import styled from "styled-components";
import { NavLink } from 'react-router'

const SideRoot = styled.aside`
   top: 0;
   left: 0;
   width: 230px;
   min-width: 230px;
   height: 100vh;
   position: fixed;
   background: #101018;
   color: #fff;
   display: flex;
   flex-direction: column;
   padding: 20px 20px 22px 20px;
   gap: 10px;
   z-index: 999;
`;

const Brand = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
   margin-bottom: 28px;
   img {
      width: 132px;
      height: auto;
   }
`;

const NavGroup = styled.nav`
   display: flex;
   flex-direction: column;
   gap: 4px;
   flex: 1;
`;

const LinkItem = styled(NavLink)`
   display: flex;
   align-items: center;
   gap: 10px;
   height: 32px;
   padding: 7px 10px;
   font-size: 14px;
   font-weight: 500;
   letter-spacing: -0.025em;
   border-radius: 8px;
   color: rgba(255, 255, 255, 0.6);
   text-decoration: none;

   &.active {
      color: #AF7AD5;
      background: rgba(175, 122, 213, 0.08);
   }
   &:hover {
      color: #fff;
      background: rgba(175, 122, 213, 0.08);
      background: rgba(255, 255, 255, 0.05);
   }
`;

const Footer = styled.div`
   margin-top:auto;
   display:flex;
   flex-direction:column;
   gap:6px;
   font-size:11px;
   color:rgba(255,255,255,0.3);
`;


export { SideRoot, Brand, NavGroup, LinkItem, Footer }